import PropTypes from "prop-types";
import React from "react";

const TechnologyContainer = ({ spaceTopClass, spaceBottomClass, bgClass, img }) => {
  return (
    <div>
      <div
        className={`funfact-area ${spaceTopClass ? spaceTopClass : ""} ${
          spaceBottomClass ? spaceBottomClass : ""
        } ${bgClass ? bgClass : ""}`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-5 col-lg-5 order-1 order-lg-2">
              <div className="funfact-content funfact-res text-center">
                <h2>Technology</h2>
                <div className="timer">
                  <p>
                  Technology covers the electronics used in the construction of robotics,
                  vehicles, machinery, etc. It is often associated with wireless smart devices:
                  technology that communicates and relays information with the internet to function
                  autonomously. Our technology curriculum combines the essentials of both coding
                  and robotics, with students creating their own technology projects.
                  </p>
                  <p>
                    Key benefits of coding include problem-solving skills,
                    creativity,
                    logical and critical thinking, and
                    exciting career choices.
                  </p>
                </div>
                <div className="funfact-btn funfact-btn--round-shape funfact-btn-red btn-hover">
                  <a href={process.env.PUBLIC_URL + "/locations"}>
                    Choose Location
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 order-2 order-lg-1">
              <div className="funfact-image">
                <img
                  src={process.env.PUBLIC_URL + img}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
TechnologyContainer.propTypes = {
  bgClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  img: PropTypes.string,
};

export default TechnologyContainer;
